/**
 * Because having ALL of our images available and up to date on the dev machines
 * is pretty impractical, we'll point the images to the live URL to be able to
 * see them.
 */
export default function (value) {
	if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
		return 'https://www.world-architects.com/' + value;
	}

	return value;
};
